import React from 'react';

import { MessageContextAction } from './message-composer-reducer';

import {
  MessageComposerContext,
  MessageComposerContextState,
  MessageComposerDispatchContext,
} from './message-composer-state';

type Props = {
  messageComposerState: MessageComposerContextState;
  dispatch: React.Dispatch<MessageContextAction>;
};

/**
 * Provides context and dispatch to components below to clean up
 * Providing necessary message composer context
 *
 * Similar to
 * https://react.dev/learn/scaling-up-with-reducer-and-context#moving-all-wiring-into-a-single-file
 *
 * @see https://react.dev/reference/react/createContext#provider
 */
export const MessageComposerProvider = ({
  children,
  messageComposerState,
  dispatch,
}: React.PropsWithChildren<Props>) => (
  <MessageComposerContext.Provider value={messageComposerState}>
    <MessageComposerDispatchContext.Provider value={dispatch}>
      {children}
    </MessageComposerDispatchContext.Provider>
  </MessageComposerContext.Provider>
);
